

























import {BudgetOrdersSummary} from '../../../build/swagger-code-extranet-api-definition';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class BudgetOrdersItem extends Vue {
    @Prop({required: true}) public summary: BudgetOrdersSummary;
    @Prop() public checkBudgetOrdersUrl: string;

    get darkLayer(): HTMLElement {
        return this.$refs.budgetOrdersDarkLayer as HTMLElement;
    }

    public onBudgetOrdersShow() {
        this.darkLayer.setAttribute('show', '');
        this.$emit('closeSideMenu');
    }

    public onBudgetOrdersHide() {
        this.darkLayer.removeAttribute('show');
    }
}
